import {Module} from 'vuex';

/**
 * 项目案例-评论
 * @type {Module}
 */
export const evaluation = {
  namespaced: true,
  state: {
    // 分类导航
    arrClassNavList: [
    //   {
    //     name: "全部",
    //     key: "all",
    //     len: 1,
    //   },
    //   {
    //     name: "有图/视频",
    //     key: "mate",
    //     len: 1,
    //   },
    //   {
    //     name: "追加",
    //     key: "add",
    //     len: 1,
    //   },
    ],
    // 激活的分类导航
    sActiveClassNav: "",
    // 评论标签
    arrEvaTag: [
      {
        name: "施工标准严苛",
        key: "key1",
      },
      {
        name: "服务专业",
        key: "key2",
      },
      {
        name: "设计严谨",
        key: "key3",
      },
      {
        name: "主动解决问题",
        key: "key4",
      },
      {
        name: "验收及时",
        key: "key5",
      },
    ],
    // 评论列表
    arrEvaList: [],
    // 评论列表
    _arrEvaList: [
      {
        username: "", // 用户名
        self: true, // 本案例用户评价
        selfAdd: true, // 追评，
        time: "", // 评价时间
        evaContent: [
          {
            type: "",
            id: 1,
            evaLongTags: [
              // 长评分
              {
                name: "",
                value: 0,
              },
            ],
            evaContext: "", // 评价内容
            audioTime: 50, // 语音时长
            audioUrl: "",
            tags: [],
            evaValue:"",
            mateResult:[]
          },
        ],
      },
    ],
    // 当前激活的标签
    sActiveTagKey: null,
    // 当前的排序方式
    sActiveOrder: "up",
  },
  mutations: {
    /**
     * 改变激活的导航
     * @param state
     * @param typeAction 携带name
     * @constructor
     */
    CHANGE_ACTIVE_NAV: (state, typeAction) => {
      state.sActiveClassNav = typeAction.name;
      state.sActiveTagKey = null;
    },
    /**
     * 改变评论列表数据
     * @param state
     * @param typeAction
     * @constructor
     */
    CHANGE_EVA_LIST: (state, typeAction) => {
      const { list, push } = typeAction;
      if (push) {
        state.arrEvaList.push(...list);
      } else {
        state.arrEvaList = list;
      }
    },
    /**
     * 改变当前激活的标签
     * @param state
     * @param typeAction
     * @constructor
     */
    CHANGE_ACTIVE_TAG_KEY: (state, typeAction) => {
      const { key } = typeAction;
      state.sActiveTagKey = key === state.sActiveTagKey ? null : key;
    },
    /**
     * 改变排序方式
     * @param state
     * @param typeAction
     * @constructor
     */
    CHANGE_ACTIVE_ORDER_TYPE: (state, typeAction) => {
      const { key } = typeAction;
      state.sActiveOrder = key;
    },
  },
  actions: {
    /**
     * 请求评论数据
     * @param commit
     * @param state
     * @param typePayload
     * @return {Promise<void>}
     */
    async fetchEvaluateList({ commit, state }, typePayload) {
      const { labKey } = typePayload;
      switch (labKey) {
        case "mate":
          commit({ type: "CHANGE_EVA_LIST", list: state._arrEvaList.filter((i) => i.evaContent?.some((c) => c.mateResult)) });
          break;
        case "add":
          commit({ type: "CHANGE_EVA_LIST", list: state._arrEvaList.filter((i) => i.selfAdd) });
          break;
        default:
          commit({ type: "CHANGE_EVA_LIST", list: state._arrEvaList });
          break;
      }
    },
  },
  getters: {
    /**
     * 获取各种评论标签的数量
     * @param state
     */
    evaTagCount(state) {
      const names = state.arrEvaTag.map((i) => i.name);
      const result = {};
      names.forEach((name) => {
        result[name] = state.arrEvaList.filter((eva) => eva.evaContent?.some((i) => i.tags?.includes(name))).length;
      });
      return result;
    },
    /**
     * 根据激活的标签过滤评论
     */
    evaFilterList(state) {
      const { name } = state.arrEvaTag.find((i) => i.key === state.sActiveTagKey) || {};

      const order = state.sActiveOrder;

      const result = JSON.parse(JSON.stringify(state.arrEvaList))
        .map((i) => {
          i._time = new Date(i.time).valueOf();
          return i;
        })
        .sort((a, b) => (order !== "up" ? b._time - a._time : a._time - b._time));

      return name
        ? result
            .filter((eva) => eva.evaContent?.some((i) => i.tags?.includes(name)))
            .map((i) => {
              i.evaContent = i.evaContent?.filter((eva) => eva.tags?.includes(name));
              return i;
            })
        : result;
    },
  },
};

